var BarcodeType;
(function (BarcodeType) {
    BarcodeType["CODE_25"] = "code-25";
    BarcodeType["CODE_39"] = "code-39";
    BarcodeType["CODE_128"] = "code-128";
    BarcodeType["DATA_MATRIX"] = "data-matrix";
    BarcodeType["EAN_13"] = "ean-13";
    BarcodeType["INFRARED"] = "infrared";
    BarcodeType["MANUAL"] = "manual";
    BarcodeType["QR_CODE"] = "qr-code";
    BarcodeType["UNKNOWN"] = "unknown";
})(BarcodeType || (BarcodeType = {}));
var BarcodeReaderType;
(function (BarcodeReaderType) {
    BarcodeReaderType["CAMERA"] = "camera";
    BarcodeReaderType["INFRARED"] = "infrared";
    BarcodeReaderType["MANUAL"] = "manual";
})(BarcodeReaderType || (BarcodeReaderType = {}));
export { BarcodeReaderType, BarcodeType, };
//# sourceMappingURL=barcode-constants.js.map